import React from 'react';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';

class Paginator extends React.Component {
  render() {
    const { meta, settings } = this.props;
    const hasPagination = Boolean(meta && meta.current_page);

    if (!hasPagination && !settings) {
      return null;
    }

    return (
      <div className="table-footer">
        {settings && <div className="table-footer__settings">{settings}</div>}
        {hasPagination && (
          <div className="table-footer__pagination">
            <Desktop meta={ meta } changePage={ this.props.changePage } />
            <Mobile meta={ meta } changePage={ this.props.changePage } />
          </div>
        )}
      </div>
    );
  }
}

Paginator.defaultProps = {
  changePage: () => { },
  meta: {},
  settings: null
};

export { Paginator };
